import script from "./AtomCheckBoxButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AtomCheckBoxButton.vue?vue&type=script&setup=true&lang=ts"

import "./AtomCheckBoxButton.vue?vue&type=style&index=0&id=25b86ba6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25b86ba6"]])

export default __exports__